import { DateTimeIcon } from "pages/meter/history/components";
import { IUser } from "pages/meter/types";

import { UserDropdown} from "pages/meter/components"

type IProps = {
  users?: IUser[];
  currentUser?: IUser;
  dateStr?: string;
  onChange: (user: IUser) => void;
};

export const Description: React.FC<IProps> = ({
  users,
  currentUser,
  dateStr,
  onChange,
}) => {


  return (
    <div className="flex text-[11px] text-gray999 items-center justify-between pt-0 pb-[21px] px-[19px]">
      <div className="flex items-center ml-[6px]">
        <span>mmHg</span>
        <div className="flex items-center ml-2 ">
          <span className="inline-block w-2 h-2 rounded-full mr-1 bg-primary"></span>
          <span>SYS</span>
        </div>
        <div className="flex items-center ml-2 ">
          <span className="inline-block w-2 h-2 rounded-full mr-1 bg-[#fff629]"></span>
          <span>DIA</span>
        </div>
      </div>
      {dateStr && (
        <div className="flex items-start gap-[3px] text-primary">
          <DateTimeIcon />
          {dateStr}
        </div>
      )}
      <UserDropdown
        avatar
        mini
        currentUser={currentUser}
        users={users}
        onChange={onChange}
      />
    </div>
  );
};
